import React from "react";

const NotFound = () => (
  <div style={{ minHeight: "60vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "#00182c" }}>
    <h1>404</h1>
    <h2>Página não encontrada</h2>
    <p>A página que você procura não existe.</p>
    <a href="/" style={{ color: "#009ece", marginTop: "1rem" }}>Voltar para a Home</a>
  </div>
);

export default NotFound;